module.exports = __webpack_public_path__ + "media/application/images/icons/cross-9bd5d685f57095f0aa2e32631a2e8390.svg";